import setupAxios from '../../lib/redux/setupAxios'

export const getAllDevices = async (apiQueryParams) => {
    return setupAxios
        .get('/devices', { params: apiQueryParams })
        .then((res) => res?.data?.data)
}


export const getDeviceByID = async (id) => {
    return setupAxios.get(`/devices/${id}`).then((res) => res?.data?.data[0])
}


export const getDevicePlatform = async (queryParams) => {
    return setupAxios
        .get(`/devices/get_platforms`, {
            params: queryParams,
        })
        .then((res) => res?.data?.data)
}

export const getAllDeviceType = async (queryParams) => {
    return setupAxios
        .get(`/device_types`, {
            params: { activ_yn: 'Y', ...queryParams },
        })
        .then((res) => res?.data?.data)
}

// device filteration
export const getFilteredDevices = async (payload) => {
    return setupAxios
        .post('/devices/filter', payload)
        .then((res) => res?.data?.data)
}

// update device

export const updateDevice = async ({ id, data }) => {
    return setupAxios.post(`/devices/${id}`, data).then((res) => res?.data)
}

// Unassign Devices

export const unAssignDevice = async (id) => {
    return setupAxios
        .put(`/devices/unassign_device/${id}`)
        .then((res) => res?.data)
}

// Delete device

export const deleteDevice = async (id) => {
    return setupAxios.delete(`/devices/${id}`).then((res) => res?.data)
}


// Fetch device count
export const fetchUserDeviceCount = async (id) => {
    return await setupAxios.get(`/users/get_user_devices_count/${id}`).then((res) => res?.data)   
  };
  
  // Update device count
  export const updateUserDeviceCount = async ({ id, count }) => {
    return await setupAxios.put(`/users/update_user_devices_count/${id}`, {
      manual_device_count: count,
    }).then((res) => res?.data)
  };
  
  // confirm device count 
export const confirmUserDevicesCount = async (id) => {
    return await setupAxios.put(`/users/confirm_user_devices_count/${id}`).then((res) => res?.data);
  };
  
  
  